module.exports = __webpack_public_path__ + "media/images/social_icons/pinterest_square-d9ae301e22564324c90dc282c5a0579c.png";